module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABDUlEQVQ4T+3TyypGURgG4OeXY+EiXAVGBoSUcxS5BvdiaGKmnKWEcgEO18A9YOK8terb2f3t/+DPwMCe7rWe9X7valWyLGvzi1/lHyxrcxobqGAdx/Uqb9ThArbRHsgHVrFXC60HzmInsCdk6Mc7VnBQhtYC05i76EDCJvGJ8wK6XDZ+GTiFfXQGNoGrSDMYaB/esISTYtJqMCU5DOwxkuVYvq+IvmIRp/nPIjiOI3QhYSnZdY3yq9F5nKW1OTgWfXQ3geVnDAWSxn/BHC4SOBo99OAhkt00+byL6DNmEniHgcDS2LdNYvmy4Ujai/sEbmIEay1gRXQLl41eyg/Dfl/Kjze28vRaOuTvj/wFm1hxtSw4TP0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/coupon/coupon_icon_up.png
// module id = oili
// module chunks = 3